module.exports = __webpack_public_path__ + "img/ex05.752e2a42.png";